export default __webpack_public_path__ + "static/media/card_premium_3.8a56a2ab.svg";